import { Box } from "@mui/material";
import { maskedContent } from "helpers/maskedContent";
import styles from "../ContractCompare.styles";
import { AlertCircleGlyph, AlertTriangleGlyph } from "./ContractCompareIcons";

export interface CompareMessage {
  /** `warning`: busy, try again in N seconds. `danger`: a refusal that names no file. */
  tone: "warning" | "danger";
  text: string;
}

interface CompareNoticeProps {
  message: CompareMessage | null;
  /**
   * Said once, to screen readers, when a busy answer arrives. The visible text counts down every second and is not a
   * live region: a reader would otherwise repeat it for up to a minute.
   */
  announce?: string | null;
}

/**
 * The one message that belongs to the whole compare (busy, or a refusal that names no file), directly under the page
 * header, and the screen-reader line that says a busy answer once. Nothing is drawn when there is no message.
 */
const CompareNotice = ({ message, announce }: CompareNoticeProps) => (
  <>
    {announce && (
      <Box component="p" role="status" sx={styles.srOnly} {...maskedContent}>
        {announce}
      </Box>
    )}
    {message && (
      <Box
        component="p"
        role={message.tone === "danger" ? "alert" : undefined}
        sx={styles.compareMessage(message.tone)}
        {...maskedContent}
      >
        {message.tone === "danger" ? (
          <AlertCircleGlyph sx={{ width: 18, height: 18, flexShrink: 0 }} />
        ) : (
          <AlertTriangleGlyph sx={{ width: 18, height: 18, flexShrink: 0 }} />
        )}
        {message.text}
      </Box>
    )}
  </>
);

export default CompareNotice;
